import React from "react";
export default function PreviousButton({ onClick, label, disabled = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="underline text-brand-500 font-semibold text-sm hover:text-primary-900"
      disabled={disabled}
    >
      {label || "Previous"}
    </button>
  );
}
